import {
  action,
  Action,
  createStore,
  createTypedHooks,
  Store,
} from "easy-peasy";

import makeAuthStore, { AuthStore } from "./authStore";
import makePreferencesStore, { PreferencesStore } from "./preferencesStore";

import { StoreMaker } from "./storeTypes";

export interface AppStore {
  isSetup: boolean;
  setIsSetup: Action<AppStore, boolean>;

  auth: AuthStore;
  preferences: PreferencesStore;

  reset: Action<AppStore, void>;
}

const makeStore: StoreMaker<Store<AppStore>> = (defaultValues) =>
  createStore<AppStore>({
    isSetup: defaultValues?.isSetup || false,
    setIsSetup: action((state, payload) => {
      state.isSetup = payload;
    }),

    preferences: makePreferencesStore(defaultValues),
    auth: makeAuthStore(defaultValues),

    reset: action((state, payload) => {
      state.auth.tokens = undefined;
      state.isSetup = false;
    }),
  });

const { useStore, useStoreActions, useStoreState, useStoreDispatch } =
  createTypedHooks<AppStore>();

export { useStore };
export { useStoreActions };
export { useStoreState };
export { useStoreDispatch };

export default makeStore;
